import { render, staticRenderFns } from "./FieldEditor.vue?vue&type=template&id=38482939&scoped=true"
import script from "./FieldEditor.vue?vue&type=script&lang=js"
export * from "./FieldEditor.vue?vue&type=script&lang=js"
import style0 from "./FieldEditor.vue?vue&type=style&index=0&id=38482939&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38482939",
  null
  
)

export default component.exports